"use strict";
/**
 * Copyright 2021 Angus.Fenying <fenying@litert.org>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.captureStackTrace = exports.notStartOrEndWith = exports.createDecreaseCodeIndex = exports.createIncreaseCodeIndex = void 0;
/**
 * Create a code index function that always return the next bigger integer of the previous one.
 *
 * @param base  The first integer.
 */
function createIncreaseCodeIndex(base) {
    return function () { return base++; };
}
exports.createIncreaseCodeIndex = createIncreaseCodeIndex;
/**
 * Create a code index function that always return the biggest integer that smaller than the previous one.
 *
 * @param base  The first integer.
 */
function createDecreaseCodeIndex(base) {
    return function () { return base--; };
}
exports.createDecreaseCodeIndex = createDecreaseCodeIndex;
function notStartOrEndWith(str, searchString) {
    var frag = str.split('.');
    return frag.every(function (i) {
        return !i.startsWith(searchString)
            && !i.endsWith(searchString);
    });
}
exports.notStartOrEndWith = notStartOrEndWith;
// eslint-disable-next-line @typescript-eslint/ban-types
function captureStackTrace(targetObject, constructorOpt) {
    if (Error.captureStackTrace) {
        Error.captureStackTrace(targetObject, constructorOpt);
    }
    else {
        targetObject.stack = new Error().stack;
    }
}
exports.captureStackTrace = captureStackTrace;
//# sourceMappingURL=Utilites.js.map